import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/** Floating back-to-top button. Renders once scrolled past `threshold` px. */
export default function BackToTop({ threshold = 600 }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full border border-[#00aaff]/40 bg-[#0d1b2e] text-[#00aaff] flex items-center justify-center shadow-[0_0_20px_rgba(0, 170, 255,0.35)] hover:bg-[#00aaff]/15 transition-colors"
      aria-label="Back to top"
      data-testid="back-to-top"
    >
      <ArrowUp size={18} />
    </button>
  );
}
